import React, {memo, useCallback, useState} from 'react';
import './index.scss';
import iconEdit from '../../assets/images/icons/scenario/scenario-edit.png';
import iconDelete from '../../assets/images/icons/scenario/clear-2.png';

import {
    toggleScenarioTriggerPopupScreenAction,
    toggleScenarioTriggerScreenAction,
} from '../../store/ui/actions';
import {useRPC} from '../../hooks/rpc';
import {useOutsideDetector} from '../../hooks/outside-detector';
import iconCancel from '../../assets/images/icons/alarm/cancel.png';
import iconOK from '../../assets/images/icons/alarm/ok.png';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useLocalization} from "../../hooks/localization";

export const ScenarioTriggerPopupScreen = memo(function ScenarioTriggerPopupScreen() {
    const {t} = useLocalization();
    const dispatch = useDispatch();

    const visible = useSelector(state => state.ui.triggerPopupScreen.visible);
    const selectedTrigger = useSelector(state => state.ui.triggerPopupScreen.selectedTrigger);

    const [rpc] = useRPC();
    const [isDeleting, setDeleting] = useState(false);
    const centerAreaRef = useOutsideDetector(!isDeleting, () => {
        dispatch(toggleScenarioTriggerPopupScreenAction(null));
    });

    const edit = useCallback(() => {
        dispatch(toggleScenarioTriggerScreenAction(selectedTrigger));
        dispatch(toggleScenarioTriggerPopupScreenAction(null));
    }, [selectedTrigger, dispatch]);

    const deleteSelected = useCallback(() => {
        setDeleting(false);
        return rpc.deleteScenarioTrigger(selectedTrigger.id)
            .finally(() => {
                dispatch(toggleScenarioTriggerPopupScreenAction(null));
            });
    }, [selectedTrigger, rpc, dispatch]);

    if (!visible) {
        return null;
    }

    return (
        <>
            <div className={'scenario-trigger-screen-wrapper'}>
                <div className="center-area" ref={centerAreaRef}>
                    <span>{selectedTrigger.name}</span>
                    <div className="scenario-buttons">
                        <div className="scenario-button" {...onClickHandler(edit)}>
                            <img src={iconEdit} alt=''/>
                            {t('EDIT')}
                        </div>
                        <div className="scenario-button" {...onClickHandler(() => setDeleting(true))}>
                            <img src={iconDelete} alt=''/>
                            {t('DELETE')}
                        </div>
                    </div>
                </div>
            </div>
            {
                renderIf(isDeleting)(() =>
                    <div className='scenario-screen-wrapper no-background'>
                        <div className="center-area darker">
                            <span>
                                <b>{selectedTrigger.name.toUpperCase()} {t('TRIGGER_WILL_BE_DELETED')}</b>
                                <b>{t('DO_YOU_CONFIRM')}</b>
                            </span>
                            <div className='scenario-buttons'>
                                <div {...onClickHandler(() => setDeleting(false))} className="scenario-setup-button">
                                    <div className='image abort'>
                                        <img src={iconCancel} alt=''/>
                                    </div>
                                    <b>{t('CANCEL')}</b>
                                </div>
                                <div {...onClickHandler(deleteSelected)} className="scenario-setup-button">
                                    <div className='image set'>
                                        <img src={iconOK} alt=''/>
                                    </div>
                                    <b>{t('DELETE')}</b>
                                </div>
                            </div>
                        </div>
                    </div>,
                )
            }
        </>
    );
});
